'use strict';

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var multihashing = require('multihashing-async');

var protobuf = require('protons');

var bs58 = require('bs58');

var crypto = require('./ed25519');

var pbm = protobuf(require('./keys.proto'));

var Ed25519PublicKey = /*#__PURE__*/function () {
  function Ed25519PublicKey(key) {
    _classCallCheck(this, Ed25519PublicKey);

    this._key = ensureKey(key, crypto.publicKeyLength);
  }

  _createClass(Ed25519PublicKey, [{
    key: "verify",
    value: function verify(data, sig, callback) {
      ensure(callback);
      crypto.hashAndVerify(this._key, sig, data, callback);
    }
  }, {
    key: "marshal",
    value: function marshal() {
      return Buffer.from(this._key);
    }
  }, {
    key: "bytes",
    get: function get() {
      return pbm.PublicKey.encode({
        Type: pbm.KeyType.Ed25519,
        Data: this.marshal()
      });
    }
  }, {
    key: "equals",
    value: function equals(key) {
      return this.bytes.equals(key.bytes);
    }
  }, {
    key: "hash",
    value: function hash(callback) {
      ensure(callback);
      multihashing(this.bytes, 'sha2-256', callback);
    }
  }]);

  return Ed25519PublicKey;
}();

var Ed25519PrivateKey = /*#__PURE__*/function () {
  // key       - 64 byte Uint8Array or Buffer containing private key
  // publicKey - 32 byte Uint8Array or Buffer containing public key
  function Ed25519PrivateKey(key, publicKey) {
    _classCallCheck(this, Ed25519PrivateKey);

    this._key = ensureKey(key, crypto.privateKeyLength);
    this._publicKey = ensureKey(publicKey, crypto.publicKeyLength);
  }

  _createClass(Ed25519PrivateKey, [{
    key: "sign",
    value: function sign(message, callback) {
      ensure(callback);
      crypto.hashAndSign(this._key, message, callback);
    }
  }, {
    key: "public",
    get: function get() {
      if (!this._publicKey) {
        throw new Error('public key not provided');
      }

      return new Ed25519PublicKey(this._publicKey);
    }
  }, {
    key: "marshal",
    value: function marshal() {
      return Buffer.concat([Buffer.from(this._key), Buffer.from(this._publicKey)]);
    }
  }, {
    key: "bytes",
    get: function get() {
      return pbm.PrivateKey.encode({
        Type: pbm.KeyType.Ed25519,
        Data: this.marshal()
      });
    }
  }, {
    key: "equals",
    value: function equals(key) {
      return this.bytes.equals(key.bytes);
    }
  }, {
    key: "hash",
    value: function hash(callback) {
      ensure(callback);
      multihashing(this.bytes, 'sha2-256', callback);
    }
    /**
     * Gets the ID of the key.
     *
     * The key id is the base58 encoding of the SHA-256 multihash of its public key.
     * The public key is a protobuf encoding containing a type and the DER encoding
     * of the PKCS SubjectPublicKeyInfo.
     *
     * @param {function(Error, id)} callback
     * @returns {undefined}
     */

  }, {
    key: "id",
    value: function id(callback) {
      this.public.hash(function (err, hash) {
        if (err) {
          return callback(err);
        }

        callback(null, bs58.encode(hash));
      });
    }
  }]);

  return Ed25519PrivateKey;
}();

function unmarshalEd25519PrivateKey(bytes, callback) {
  try {
    bytes = ensureKey(bytes, crypto.privateKeyLength + crypto.publicKeyLength);
  } catch (err) {
    return callback(err);
  }

  var privateKeyBytes = bytes.slice(0, crypto.privateKeyLength);
  var publicKeyBytes = bytes.slice(crypto.privateKeyLength, bytes.length);
  callback(null, new Ed25519PrivateKey(privateKeyBytes, publicKeyBytes));
}

function unmarshalEd25519PublicKey(bytes) {
  bytes = ensureKey(bytes, crypto.publicKeyLength);
  return new Ed25519PublicKey(bytes);
}

function generateKeyPair(_bits, cb) {
  if (cb === undefined && typeof _bits === 'function') {
    cb = _bits;
  }

  crypto.generateKey(function (err, keys) {
    if (err) {
      return cb(err);
    }

    var privkey;

    try {
      privkey = new Ed25519PrivateKey(keys.secretKey, keys.publicKey);
    } catch (err) {
      cb(err);
      return;
    }

    cb(null, privkey);
  });
}

function generateKeyPairFromSeed(seed, _bits, cb) {
  if (cb === undefined && typeof _bits === 'function') {
    cb = _bits;
  }

  crypto.generateKeyFromSeed(seed, function (err, keys) {
    if (err) {
      return cb(err);
    }

    var privkey;

    try {
      privkey = new Ed25519PrivateKey(keys.secretKey, keys.publicKey);
    } catch (err) {
      cb(err);
      return;
    }

    cb(null, privkey);
  });
}

function ensure(cb) {
  if (typeof cb !== 'function') {
    throw new Error('callback is required');
  }
}

function ensureKey(key, length) {
  if (Buffer.isBuffer(key)) {
    key = new Uint8Array(key);
  }

  if (!(key instanceof Uint8Array) || key.length !== length) {
    throw new Error('Key must be a Uint8Array or Buffer of length ' + length);
  }

  return key;
}

module.exports = {
  Ed25519PublicKey: Ed25519PublicKey,
  Ed25519PrivateKey: Ed25519PrivateKey,
  unmarshalEd25519PrivateKey: unmarshalEd25519PrivateKey,
  unmarshalEd25519PublicKey: unmarshalEd25519PublicKey,
  generateKeyPair: generateKeyPair,
  generateKeyPairFromSeed: generateKeyPairFromSeed
};